module.exports = {
          srcSet: __webpack_public_path__ + "43bbc09b732b8f562db8c1782fed671f-298.png"+" 298w",
          images:[ {path: __webpack_public_path__ + "43bbc09b732b8f562db8c1782fed671f-298.png",width: 298,height: 298}],
          src: __webpack_public_path__ + "43bbc09b732b8f562db8c1782fed671f-298.png",
          toString:function(){return __webpack_public_path__ + "43bbc09b732b8f562db8c1782fed671f-298.png"},
          
          width: 298,
          height: 298
        }